import * as echarts from "echarts";
import { useEffect, useRef } from "react";
const Echart3DBar: React.FC<{
  dataOptions: {
    name: string;
    value: number;
  }[];
}> = ({ dataOptions = [] }) => {
  const myRef = useRef<any>();
  useEffect(() => {
    const myChart = echarts.init(myRef.current, undefined, {
      renderer: "canvas",
      useDirtyRect: false,
    });

    let yList: any[] = [];
    let xData: any[] = [];
    dataOptions.forEach((item) => {
      yList.push(item.value);
      xData.push(item.name);
    });
    // yList.push(20);
    const barWidth = 20;
    let colors: any[] = [];
    for (let i = 0; i < yList.length; i++) {
      colors.push({
        type: "linear",
        x: 0,
        x2: 1,
        y: 0,
        y2: 0,
        colorStops: [
          {
            offset: 0,
            color: "#73fcff", // 最左边
          },
          {
            offset: 0.5,
            color: "#86eef1", // 左边的右边 颜色
          },
          {
            offset: 0.5,
            color: "#5ad6d9", // 右边的左边 颜色
          },
          {
            offset: 1,
            color: "#3dc8ca",
          },
        ],
      });
    }
    const animationDuration = 15000;
    const option = {
      //   backgroundColor: "#010d3a",
      animationDuration,
      //提示框
      tooltip: {
        trigger: "axis",
        formatter: "{b} : {c}",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
        },
      },
      /**区域位置*/
      grid: {
        left: "10%",
        right: "10%",
        top: "10%",
        bottom: "10%",
      },
      //X轴
      xAxis: {
        data: xData,
        type: "category",
        axisLine: {
          show: false,
          lineStyle: {
            color: "rgba(255,255,255,1)",
            shadowColor: "rgba(255,255,255,1)",
            shadowOffsetX: "20",
          },
          symbol: ["none", "arrow"],
          symbolOffset: [0, 25],
        },
        splitLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          //   margin: 30,
          fontSize: 15,
        },
      },
      yAxis: {
        show: true,
        splitNumber: 4,
        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#075858",
          },
        },
        axisLabel: {
          color: "#FFFFFF",
          //   margin: 30,
          fontSize: 15,
        },
      },
      series: [
        {
          type: "bar",
          barWidth: barWidth,
          animationDuration,
          itemStyle: {
            normal: {
              color: function (params: any) {
                return colors[params.dataIndex % 7];
              },
            },
          },
          label: {
            show: true,
            // position: [barWidth / 2, -(barWidth + 20)],
            position: "top",
            color: "#ffffff",
            fontSize: 14,
            fontStyle: "bold",
            align: "center",
          },
          data: yList,
        },
        {
          z: 2,
          type: "pictorialBar",
          animationDuration,
          data: yList,
          symbol: "diamond",
          symbolOffset: [0, "50%"],
          symbolSize: [barWidth, barWidth * 0.5],
          itemStyle: {
            normal: {
              color: function (params: any) {
                return colors[params.dataIndex % 7];
              },
            },
          },
        },
        {
          z: 3,
          type: "pictorialBar",
          symbolPosition: "end",
          data: yList,
          symbol: "diamond",
          symbolOffset: [0, "-50%"],
          symbolSize: [barWidth, barWidth * 0.5],
          itemStyle: {
            normal: {
              borderWidth: 0,
              color: function (params: any) {
                return colors[params.dataIndex % 7]?.colorStops[0]?.color;
              },
            },
          },
        },
      ],
    };

    if (option && typeof option === "object") {
      myChart.setOption(option);
    }

    const interValId = setInterval(() => {
      myChart.setOption(option);
    }, 200);
    return () => {
      clearInterval(interValId);
    };
  }, [dataOptions]);
  return (
    <div
      ref={myRef}
      style={{
        height: "280px",
      }}
    ></div>
  );
};
export default Echart3DBar;
